import { useEffect } from "react";
import { Mail, Phone } from "lucide-react";

const Privacy = () => {
  useEffect(() => {
    document.title = "Gizlilik Politikası | Reklam Uzmanı";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Reklam Uzmanı Gizlilik Politikası. Kişisel verilerinizin korunması ve kullanımı hakkında detaylı bilgi.');
    }
    
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);
    
    window.scrollTo(0, 0);
    
    return () => {
      document.head.removeChild(metaRobots);
    };
  }, []);

  return (
    <div className="bg-white min-h-screen pt-20">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#012f23] to-[#059669] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Gizlilik Politikası
          </h1>
          <p className="text-gray-200 text-lg">
            Son Güncelleme: 16 Ekim 2025
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              1. Veri Sorumlusu
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-3">
              <p>
                <strong>Ticari Unvan:</strong> Reklam Uzmanı
              </p>
              <p>
                <strong>Sorumlu Kişi:</strong> Reklam Uzmanı Ekibi (Google Ads Uzmanı)
              </p>
              <p>
                <strong>Adres:</strong> Adnan Kahveci, Yavuz Sultan Selim Blv. uyum çarşı içi kat 1 iç kapı no 72, 34528 Beylikdüzü/İstanbul
              </p>
              <p>
                <strong>E-posta:</strong> info@reklam-uzmani.com.tr
              </p>
              <p>
                <strong>Telefon:</strong> +90 535 838 62 97
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              2. Toplanan Kişisel Veriler
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Web sitemizi ziyaret ettiğinizde ve hizmetlerimizi kullandığınızda aşağıdaki kişisel veriler toplanabilir:
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                2.1. Kişisel Bilgiler
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Ad ve soyad</li>
                <li>E-posta adresi</li>
                <li>Telefon numarası</li>
                <li>İşletme bilgileri (firma adı, adres, faaliyet alanı)</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                2.2. Teknik Veriler
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>IP adresi</li>
                <li>Tarayıcı tipi ve versiyonu</li>
                <li>Cihaz bilgisi (mobil, masaüstü)</li>
                <li>İşletim sistemi</li>
                <li>Ekran çözünürlüğü</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                2.3. Kullanım Verileri
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Ziyaret edilen sayfalar</li>
                <li>Sayfa görüntüleme süreleri</li>
                <li>Tıklama verileri</li>
                <li>Oturum süreleri</li>
                <li>Yönlendirme kaynakları (hangi siteden geldiğiniz)</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                2.4. Çerez Verileri
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Google Analytics çerezleri</li>
                <li>Google Ads dönüşüm takip çerezleri</li>
                <li>Google Ads remarketing çerezleri</li>
                <li>Kampanya performans çerezleri</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              3. Kişisel Verilerin Kullanım Amaçları
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Toplanan kişisel verileriniz aşağıdaki amaçlarla kullanılmaktadır:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Google Ads reklam yönetimi hizmetlerinin sunulması</li>
                <li>Müşteri iletişimi ve destek hizmetlerinin sağlanması</li>
                <li>Teklif, fiyatlandırma ve sözleşme süreçlerinin yürütülmesi</li>
                <li>Google Ads kampanyalarının optimizasyonu (Arama, Haritalar, YouTube, Display)</li>
                <li>Web sitesi performansının analiz edilmesi ve geliştirilmesi</li>
                <li>Kullanıcı deneyiminin iyileştirilmesi</li>
                <li>Pazarlama ve iletişim faaliyetleri (açık rıza alınarak)</li>
                <li>Hukuki yükümlülüklerin yerine getirilmesi</li>
                <li>İstatistiksel analiz ve raporlama</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              4. Kişisel Verilerin Paylaşımı ve Aktarımı
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Kişisel verileriniz, aşağıdaki durumlar haricinde üçüncü taraflarla paylaşılmaz:
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                4.1. Hizmet Sağlayıcılar
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Google LLC (ABD):</strong> Analytics, Google Ads API - anonim analiz ve reklam optimizasyonu, YouTube Ads ve Display Network yönetimi</li>
                <li><strong>Bulut Hizmet Sağlayıcıları:</strong> Güvenli veri saklama ve yedekleme</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                4.2. Yasal Zorunluluklar
              </h3>
              <p className="mb-4">
                Mahkeme kararı, yasal düzenlemeler veya resmi kurum talepleri doğrultusunda verileriniz ilgili mercilerle paylaşılabilir.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                4.3. Veri Güvenliği Taahhüdü
              </h3>
              <p className="mb-4">
                <strong>Kişisel verileriniz hiçbir şekilde satılmaz, kiralanmaz veya ticari amaçlarla üçüncü taraflara devredilmez.</strong>
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              5. Kişisel Veri Sahibinin Hakları
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                KVKK kapsamında aşağıdaki haklara sahipsiniz:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>İşlenmişse buna ilişkin bilgi talep etme</li>
                <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
                <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
                <li>Kanunda öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini talep etme</li>
                <li>Aktarıldığı üçüncü kişilere yukarıdaki düzeltme/silme işlemlerinin bildirilmesini isteme</li>
                <li>Münhasıran otomatik sistemler ile analiz edilmesi sonucu aleyhinize bir sonuç doğmasına itiraz etme</li>
                <li>Kanuna aykırı işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              6. Veri Güvenliği Önlemleri
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Kişisel verilerinizin güvenliği için aşağıdaki önlemler alınmaktadır:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>SSL/TLS Şifreleme:</strong> Tüm veri iletişimi şifrelenmiş kanallar üzerinden yapılır</li>
                <li><strong>Güvenli Sunucu Altyapısı:</strong> Veriler güvenli ve güncel sunucularda saklanır</li>
                <li><strong>Erişim Kontrolü:</strong> Verilere sadece yetkili personel erişebilir</li>
                <li><strong>Düzenli Güvenlik Güncellemeleri:</strong> Sistemler sürekli güncellenir ve izlenir</li>
                <li><strong>Veri Yedekleme:</strong> Düzenli otomatik yedekleme yapılır</li>
                <li><strong>Güvenlik Duvarı:</strong> Yetkisiz erişimlere karşı korunma</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              7. Veri Saklama Süreleri
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Müşteri Verileri:</strong> Hizmet süresi + 10 yıl (yasal zorunluluk - Vergi Usul Kanunu)</li>
                <li><strong>İletişim Verileri:</strong> İşlem tamamlanana kadar veya izin geri çekilene kadar</li>
                <li><strong>Pazarlama Verileri:</strong> Açık rıza geri çekilene kadar</li>
                <li><strong>Çerez Verileri:</strong> 2 yıl (Google ve Meta politikalarına uygun olarak)</li>
                <li><strong>Analitik Veriler:</strong> Anonim hale getirilerek süresiz saklanabilir</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              8. Çocukların Gizliliği
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p>
                Web sitemiz ve hizmetlerimiz 18 yaş altı bireyler için tasarlanmamıştır. Bilerek 18 yaş altındaki kişilerden kişisel veri toplamıyoruz. Eğer 18 yaşından küçükseniz, lütfen bu web sitesini kullanmayın ve kişisel bilgilerinizi paylaşmayın.
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              9. Gizlilik Politikası Değişiklikleri
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Bu Gizlilik Politikası, yasal düzenlemeler, hizmetlerimizdeki değişiklikler veya operasyonel gereklilikler doğrultusunda güncellenebilir. Önemli değişiklikler yapıldığında, bu sayfa üzerinden bilgilendirme yapılacak ve "Son Güncelleme" tarihi güncellenecektir.
              </p>
              <p>
                Düzenli olarak bu sayfayı ziyaret ederek güncel politikamızdan haberdar olmanızı öneririz.
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              10. İletişim ve Başvuru
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Gizlilik politikamız, kişisel verileriniz veya haklarınız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>E-posta:</strong> info@reklam-uzmani.com.tr</li>
                <li><strong>Telefon:</strong> +90 535 838 62 97</li>
                <li><strong>WhatsApp:</strong> +90 535 838 62 97</li>
                <li><strong>Posta Adresi:</strong> Adnan Kahveci, Yavuz Sultan Selim Blv. uyum çarşı içi kat 1 iç kapı no 72, 34528 Beylikdüzü/İstanbul</li>
              </ul>
              <p className="mt-4">
                Başvurularınız en geç 30 gün içinde yanıtlanacaktır.
              </p>
            </div>
          </section>

        </div>

        {/* İletişim CTA */}
        <div className="mt-12 p-6 bg-gradient-to-r from-[#012f23] to-[#059669] rounded-lg text-white">
          <h3 className="text-xl font-bold mb-3">
            Sorularınız mı var?
          </h3>
          <p className="mb-4 text-gray-100">
            Gizlilik politikamız hakkında sorularınız varsa bizimle iletişime geçin.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="mailto:info@reklam-uzmani.com.tr"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#012f23] rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              <Mail className="w-5 h-5" />
              info@reklam-uzmani.com.tr
            </a>
            <a
              href="tel:05326369115"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#012f23] rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              <Phone className="w-5 h-5" />
              0532 636 91 15
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
